import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { features } from "../../features";
import { isSmallViewport } from "../../utils/browser";
export const GoogleTranslateDropdown = (props)=>{
    const settings = features().automatedTranslations;
    if (settings == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const { wrapper, mobile, dropdown: gtDropdown } = props;
    const selectContainerRef = React.useRef(null);
    const ids = {
        languages: 'google_languages',
        container: 'google_languages_container',
        label: 'accesibility-label',
        placeholder: 'google_languages_placeholder'
    };
    // Using the generated dropdown in multiple components leads to issues.
    // Therefore, we only render it when the viewport matches the component type (mobile/desktop).
    const viewPortMatchesComponentType = isSmallViewport() == !!props.mobile;
    React.useEffect(()=>{
        if (gtDropdown.kind === 'loaded' && viewPortMatchesComponentType) {
            selectContainerRef.current.innerHTML = '';
            selectContainerRef.current.appendChild(gtDropdown.value);
        }
    }, [
        gtDropdown
    ]);
    const dropdown = /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            id: ids.languages,
            children: [
                /*#__PURE__*/ _jsx("svg", {
                    className: "google_languages-icon",
                    "aria-hidden": "true",
                    fill: "none",
                    height: "8",
                    viewBox: "0 0 14 10",
                    width: "12",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        clipRule: "evenodd",
                        d: "m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z",
                        fill: settings.iconFill,
                        fillRule: "evenodd"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    id: ids.container,
                    children: [
                        !mobile && /*#__PURE__*/ _jsx("label", {
                            htmlFor: "google_language_selector",
                            id: ids.label,
                            children: "Selecteer een taal"
                        }),
                        gtDropdown.kind == 'loaded' ? /*#__PURE__*/ _jsx("div", {
                            ref: selectContainerRef
                        }) : /*#__PURE__*/ _jsx("select", {
                            id: ids.placeholder,
                            className: "goog-te-combo placeholder notranslate",
                            children: /*#__PURE__*/ _jsx("option", {
                                value: ""
                            })
                        })
                    ]
                })
            ]
        })
    });
    return wrapper ? wrapper(dropdown) : dropdown;
};
